import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import fragment from "./shader/fragment.glsl";
import vertex from "./shader/vertex.glsl";
import * as dat from 'dat.gui'
// import gsap from "gsap";


export default class Sketch {
  constructor(options) {
    this.scene = new THREE.Scene();

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer({
      antialias: true
    });
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0xeeeeee, 1); 

    this.container.appendChild(this.renderer.domElement);

    this.camera = new THREE.PerspectiveCamera(
      70,
      window.innerWidth / window.innerHeight,
      0.001,
      1000
    );

    // var frustumSize = 10;
    // var aspect = window.innerWidth / window.innerHeight;
    // this.camera = new THREE.OrthographicCamera( frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, -1000, 1000 );
    this.camera.position.set(0, 0, 2);
    // this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.time = 0;

    this.isPlaying = true;
    
    this.addObjects();
    this.resize();
    this.render();
    this.setupResize();
    // this.settings();
    this.materials=[]
    this.meshes=[]
    this.groups=[]
    this.handleImages()
  }
  
  handleImages(){
    let images = [...document.querySelectorAll('img')]
    images.forEach((img,i)=>{
      let group = new THREE.Group()
      let mat = this.material.clone()
      this.materials.push(mat)
      mat.uniforms.texture1.value = new THREE.Texture(img)
      mat.uniforms.texture1.value.needsUpdate = true

      let geo = new THREE.PlaneBufferGeometry(1.7,1,20,20)

      let mesh = new THREE.Mesh(geo,mat)
      group.add(mesh)
      this.scene.add(group)
      this.groups.push(group)
      this.meshes.push(mesh)
      // this.scene.add(mesh)

      mesh.position.y = i*1.2

      group.rotation.x = -0.2
      group.rotation.y = -0.3
      group.rotation.z = -0.1
      
    })
  }
  settings() {
    let that = this;
    this.settings = {
      progress: 0,
    };
    this.gui = new dat.GUI();
    this.gui.add(this.settings, "progress", 0, 1, 0.01);
  }

  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    this.camera.updateProjectionMatrix();
  }

  addObjects() {
    let that = this;
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable"
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { value: 0 },
        texture1: { type: 't', value: null},
        resolution: { value: new THREE.Vector4() },
      },
      // wireframe: true,
      // transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment
    });

    // this.geometry = new THREE.PlaneGeometry(1, 1, 1, 1);

    // this.plane = new THREE.Mesh(this.geometry, this.material);
    // this.scene.add(this.plane);
  }

  stop() {
    this.isPlaying = false;
  }

  play() {
    if(!this.isPlaying){
      this.render()
      this.isPlaying = true;
    }
  }

  render() {
    if (!this.isPlaying) return;
    this.time += 0.05;
    if(this.materials){
      this.materials.forEach(m=>{
        m.uniforms.time.value= this.time
      })
    }
    requestAnimationFrame(this.render.bind(this));
    this.renderer.render(this.scene, this.camera);
  }
}

let sketch = new Sketch({
  dom: document.getElementById("container")
});


let speed = 0
let position = 0
let rounded = 0 

window.addEventListener('wheel',e=> {
  speed = e.deltaY * 0.0003
})
let objs = Array(5).fill({dist:0})
function raf(){
  position += speed
  speed *= 0.9
  objs.forEach((o,i)=>{
    o.dist = Math.min(Math.abs( position - i),1)
    o.dist =+ 1-o.dist**2

    let scale = 1+0.1*o.dist

    sketch.meshes[i].position.y = i*1.2 - position*1.2
    sketch.meshes[i].scale.set(scale,scale,scale)
  })
  rounded = Math.round(position)
  let diff = (rounded - position)
  position += Math.sign(diff)*Math.pow(Math.abs(diff),0.7) * 0.015
  window.requestAnimationFrame(raf)
}
raf()  